import React from 'react';
import {
	AccessorKeyColumnDef,
	getCoreRowModel,
	getPaginationRowModel,
	getSortedRowModel,
	PaginationState,
	SortingState,
	useReactTable,
} from '@tanstack/react-table';
import { CertificateDataEntry } from './CertificateRisk';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DashboardTableFooter from '../DashboardTableFooter';
import DashboardTable from '../DashboardTable';

const Table = ({
	data,
	columns,
}: {
	data: CertificateDataEntry[];
	columns: AccessorKeyColumnDef<CertificateDataEntry, string>[];
}) => {
	const [pagination, setPagination] = React.useState<PaginationState>({
		pageIndex: 0,
		pageSize: 5,
	});

	const [sorting, setSorting] = React.useState<SortingState>([
		{
			id: 'certificateExpirationDate',
			desc: false,
		},
	]);

	const { t } = useTranslation();
	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
		getSortedRowModel: getSortedRowModel(),
		onPaginationChange: setPagination,
		onSortingChange: setSorting,
		state: {
			pagination,
			sorting,
		},
	});

	return (
		<Card className="m-3 col-5" style={{ minHeight: 300 }}>
			<Card.Body>
				<Card.Title>
					<div className="d-flex">
						<span className="glyphicons glyphicons-certificate" style={{ fontSize: '2.5rem' }} />
						<span className="m-2">{t('dashboard.certificate_expires')}</span>
					</div>
				</Card.Title>
				<DashboardTable headerGroups={table.getHeaderGroups()} rows={table.getRowModel().rows} />
				<DashboardTableFooter
					pageIndex={table.getState().pagination.pageIndex}
					pageCount={table.getPageCount()}
					previousPage={table.previousPage}
					nextPage={table.nextPage}
					getCanPreviousPage={table.getCanPreviousPage}
					getCanNextPage={table.getCanNextPage}
					t={t}
				/>
			</Card.Body>
		</Card>
	);
};

export default Table;
